// extracted by mini-css-extract-plugin
export default {"checkbox-wrapper":"DB98w","checkbox":"tttJS","disabled":"VXNuC"};